import { render } from "./PlansPage.vue?vue&type=template&id=05becd14&scoped=true"
import script from "./PlansPage.vue?vue&type=script&lang=js"
export * from "./PlansPage.vue?vue&type=script&lang=js"

import "./PlansPage.vue?vue&type=style&index=0&id=05becd14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05becd14"]])

export default __exports__